import React from 'react'
import { 
  Header, 
  Navigation, 
  AboutSlider, 
  Gallery, 
  News,
  Footer } from '../components'
import css from './style.module.scss'

const HomePage = () => {
  
  return (
    <div className={css.homePage}>
      <div className='container'>

        <div>
          <Header />
        </div>
        
        <div className='wrapper'>

          <div className={css.h1} id='anchor1'>
            <h1>О нас</h1>
          </div>
          
          <div>
            <Navigation />
          </div>
          
          <div className={css.textBlock}>
            <p>Селекция бренда, анализируя результаты рекламной кампании, 
              осмысленно масштабирует SWOT-анализ. Перераспределение бюджета, 
              как следует из вышесказанного, переворачивает коллективный контент. 
              Поэтому управление брендом искажает социометрический ребрендинг: </p>
            <ul className={css.list}>
              <li>Управление брендом как искажение социометрического поиска</li>
              <li>Селекция бренда, анализируя результаты рекламной кампании бюджета как его основа</li>
              <li>Поэтому управление брендом искажает социометрический ребрендинг
                <ul className={css.subList}>
                  <li>Поэтому управление брендом искажает социометрический ребрендинг</li>
                  <li>Селекция бренда, анализируя результаты рекламной кампании</li>
                </ul>
              </li>
              <li>Диверсификация бизнеса, на первый взгляд, изменяет рекламный макет, работая над проектом.</li>
            </ul>
            <p>Можно предположить, что изменение глобальной стратегии поддерживает экспериментальный метод изучения рынка. 
              Традиционный канал стабилизирует product placement, осознавая социальную ответственность бизнеса. 
              По сути, комплексный анализ ситуации довольно неоднозначен.</p>
          </div>

          <div className={css.aboutSlider}>
            <AboutSlider />
          </div>
          
          <div className={css.textBlock}>
            <p>Можно предположить, что изменение глобальной стратегии поддерживает экспериментальный метод изучения рынка. 
              Традиционный канал стабилизирует product placement, осознавая социальную ответственность бизнеса. 
              По сути, комплексный анализ ситуации довольно неоднозначен.
            </p>

            <div className={css.quote}>
              <p>У группы «Метро» огромный опыт в строительстве, помимо жилья мы занимались инфраструктурными, промышленными, 
              социальными объектами. Компания выступала генеральным подрядчиком строительства «ЭкспоФорума», Депо «Южное», 
              также мы строили «Музей железных дорог России». Наша Компания обладает всеми необходимыми ресурсами.</p>
              <div className={css.sign}>
                <span className='label'>Геннадий Волковский</span>
                <span className='label2'>Генеральный директор компании “Метро”</span>
              </div>
            </div>

            <p>В 2018 году компания удостоилась главной архитектурной премии Европы — European Prize for Architecture. 
              Знатоки архитектуры считают нашу компанию мастером выверенных фасадов.
            </p>
          </div>

        </div>

        <div className='accordion-gallery'>
          <Gallery />
        </div>

        <div className='wrapper'>

          <div className={css.h2} id='anchor2'>
            <h2>Новости</h2>
          </div>

          <div>
            <News />
          </div>

          <div>
            <Footer />
          </div>

        </div>

      </div>

    </div>
  )
}

export default HomePage

